import React from "react";
import Flex from "./Flex";
import { Button } from "antd";

type ModalSaveCancelButtonsProps = {
  saveButtonText?: string;
  cancelButtonText?: string;
  disableSave?: boolean;
  saveButtonLoading?: boolean;
  saveButtonColor?: "danger" | "primary";
  disableCancel?: boolean;
  onSave?: () => void;
  onCancel: () => void;
};

export default function ModalSaveCancelButtons({
  saveButtonText = "Save",
  cancelButtonText = "Cancel",
  saveButtonColor = "primary",
  disableCancel = false,
  disableSave = false,
  saveButtonLoading = false,
  onSave,
  onCancel,
}: ModalSaveCancelButtonsProps) {
  return (
    <Flex
      style={{ width: "100%", marginTop: "1.5rem" }}
      align="center"
      justify="flex-end"
      gap="0.5rem"
    >
      <Button disabled={disableCancel} onClick={onCancel} type="default">
        {cancelButtonText}
      </Button>
      <Button
        disabled={disableSave}
        loading={saveButtonLoading}
        onClick={onSave}
        type="primary"
        htmlType="submit"
        danger={saveButtonColor === "danger"}
      >
        {saveButtonText}
      </Button>
    </Flex>
  );
}
